import { render, staticRenderFns } from "./CustomPricePill.vue?vue&type=template&id=6fc07b97&"
import script from "./CustomPricePill.vue?vue&type=script&lang=js&"
export * from "./CustomPricePill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports